<template>
	<section class="vx-row justify-center w-full py-2 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full w-full md:w-5/6">
			<vx-card>
				<slot name="header">
					<div class="flex mb-8">
						<router-link to="/home">
							<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
						</router-link>
						<strong class="text-primary"><small>Pilih Metode Pembayaran</small></strong>
					</div>
				</slot>
				
				<!-- Content -->
				<slot name="content" :paymentGateways="payment_gateway">
					<div class="mb-8 vx-row mx-0 w-full justify-center items-center">
						<div class="vx-col w-full md:w-1/2 mb-3 md:mb-0">
							<vs-button type="filled" class="w-full" size="large" @click.prevent="showPaymentGateway('va')">
								<small>Virtual Account</small>
							</vs-button>
						</div>
						<div class="vx-col w-full md:w-1/2">
							<vs-button type="border" class="w-full" size="large" @click.prevent="showPaymentGateway('other')">
								<small>Lainnya</small>
							</vs-button>
						</div>
					</div>
					<div class="vx-row mx-4 mb-12">
						<div 
						    class="vx-col w-full rounded-lg mb-6"
						 	v-for="(item, i) in payment_gateway"
						    :key="i"
						    style="border: 1px solid #ccc;cursor: pointer;"
						>
							<div class="vx-row py-4 px-2 items-center" @click.prevent="selectedPayment = item.id">
								<div class="vx-col w-1/4 md:w-1/6">
									<img v-if="item.file === null" :src="`/assets/images/payment_method/${item.code}.png`" alt="" class="w-12 md:w-16 block text-left" />
									<img v-else :src="item.file" alt="" class="w-12 md:w-16 block text-left" />
								</div>
								<div class="vx-col w-1/2 md:w-2/3">
									<h5 class="text-left text-sm md:text-md lg:text-lg">
										<strong>{{item.name}}</strong>
									</h5>
								</div>
								<div class="vx-col w-1/4 md:w-1/6 text-right">
									<div class="mx-auto">
										<input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</slot>
						

				<!-- Detail product -->
				<slot name="description" :transactionProduct="transactionProduct">
					<table class="w-full px-4 mb-8">
						<tr class="mb-4">
							<td class="text-left">
								<strong class="text-grey">Provider/Nominal</strong>
							</td>
							<td class="text-right">
								<strong>{{ transactionProduct.pulsa_op }} / {{ transactionProduct.pulsa_nominal }}</strong>
							</td>
						</tr>
						<tr class="mb-4">
							<td class="text-left">
								<strong class="text-grey">Pulsa</strong>
							</td>
							<td class="text-right">
								<strong>{{ formatRupiah(transactionProduct.pulsa_nominal) }}</strong>
							</td>
						</tr>
						<tr class="mb-4">
							<td class="text-left">
								<strong class="text-grey">Nominal</strong>
							</td>
							<td class="text-right">
								<strong>{{ formatRupiah(transactionProduct.pulsa_price) }}</strong>
							</td>
						</tr>
						<tr class="mb-4">
							<td class="text-left">
								<strong class="text-grey">Total Pembayaran</strong>
							</td>
							<td class="text-right">
								<strong>{{ transactionProduct.pulsa_price }}</strong>
							</td>
						</tr>
					</table>
				</slot>
				<!-- / -->

				<!-- Bayar -->
				<slot name="footer">
					<vs-button class="py-4 w-full px-8" @click.prevent="pay">
						<strong class="text-white">Bayar</strong>
					</vs-button>
				</slot>
				<!-- / -->
				
			</vx-card>
		</div>
	</section>
</template>
<script>
import { mapState } from 'vuex'
export default {
	props: ['transactionProduct'],
  data: () => ({
    paymentGateways: [],
    transaction: {}
  }),
  computed: {
    ...mapState('payment-gateway', ['va_payment_gateway', 'other_payment_gateway', 'payment_gateway']),
    selectedPayment: {
    	get() {
    		return this.$store.state['payment-gateway'].selectedPayment
    	},
    	set(val) {
    		this.$store.dispatch('payment-gateway/setSelectedPayment', val)
    	}
    }
  },
  methods: {
    pay () {
      if (this.selectedPayment === null) {
        this.$vs.notify({
          title: 'Harap Pilih Metode Pembayaran',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      const payment = this.payment_gateway.slice().find(it => it.id === this.selectedPayment)

      if (!payment) {
        this.$vs.notify({
          title: 'Metode Pembayaran Tidak ditemukan',
          text: 'coba beberapa saat lagi',
          color: 'warning',
          position: 'top-right'
        })

        return false	
      }
      this.$emit('pay', payment)
    },
    showPaymentGateway (typePayment) {
      if (typePayment === 'va') {
        const pg = this.va_payment_gateway.slice()
        this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg)
      } else {
        const pg = this.other_payment_gateway.slice()	
        this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg)
      }
    },
    getPaymentGateway () {
      this.$vs.loading()

      this.$store.dispatch('payment-gateway/getPaymentGateway', {is_enabled: 1})
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  mounted () {
    this.getPaymentGateway()
  },
  created() {
  	if(!this.transactionProduct) {
  		this.$router.push('/home')
  	}

  	this.checkVerifyAccount()
  }
}
</script>
<style>
    .rad {
        position: relative;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        font: inherit;
        width: 1rem;
        height: 1rem;
        border: 2px solid #FFCB05;
        border-radius: 50%;
    }
    .rad::before {
        content: '';
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #045532;
        background: #045532;
    }
    .rad::after {
        content: '';
        opacity: 0;
        display: block;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        background: #045532;
    }
    .rad:checked {
        border: 2px solid #045532;
        transition: .1s ease-in;
        transform: scale(1.3);
    }
    .rad:checked::after {
        opacity: 1;
    }
</style>